module.exports = __webpack_public_path__ + "static/img/iosCode.9877c2b0.png";